<template>
  <x-dialog
    dialogTitle="Add Card"
    :actions="{
      show: true,
      secondaryButtonFunction: toggleAddPaymentProfileDialog,
      primaryButtonFunction: createPaymentProfile,
      primaryButtonShow: true,
      secondaryButtonText: 'Cancel',
      primaryButtonText: 'Create',
      primaryButtonDisabled: isPrimaryButtonDisabled
    }"
    :dialogState="dialogState"
    :data-test-id="dataTestId"
    @toggleModal="toggleAddPaymentProfileDialog"
  >
    <template slot="dialog_data" v-if="dialogState">
      <div class="border mb-2 px-8">
        <loader v-if="isPrimaryButtonDisabled" />
        <Chargify
          :data-test-id="dataTestId"
          @createPaymentProfile="addPaymentToken"
          @getPaymentType="setPaymentType"
        >
          <button
            class="hide"
            slot="chargify-button"
            ref="chargifySubmit"
            type="submit"
          />
        </Chargify>
      </div>
    </template>
  </x-dialog>
</template>
<script>
import Chargify from '@/components/Common/Chargify';
export default {
  name: 'add-payment-profile-dialog',
  props: {
    toggleAddPaymentProfileDialog: {
      type: Function
    },
    getPaymentProfiles: {
      type: Function
    },
    dialogState: {
      type: Boolean
    }
  },
  data() {
    return {
      paymentToken: '',
      isPrimaryButtonDisabled: false,
      paymentType: 'card',
      dataTestId:'add-payment-card-dialog'
    };
  },
  components: {
    Chargify
  },
  methods: {
    async addPaymentToken(token) {
      this.isPrimaryButtonDisabled = true;
      this.paymentToken = token;
      if (!this.paymentToken) {
        this.isPrimaryButtonDisabled = false;
        return this.snackbar('error', this.$message.FILL_FIELDS);
      }
      try {
        const paymentProfileData = await this.$services.billing.createPaymentProfile(
          this.paymentToken
        );
        const paymentProfile = this.parseResponse(paymentProfileData);
        if (paymentProfile) {
          this.getPaymentProfiles();
        }
        this.snackbar('success', this.$message.NEW_CARD_ADDED);
        this.toggleAddPaymentProfileDialog();
      } catch (err) {
        this.snackbar('error', err);
      } finally {
        this.isPrimaryButtonDisabled = false;
      }
    },
    createPaymentProfile() {
      if (this.paymentType === 'card') {
        this.isPrimaryButtonDisabled = true;
      }
      this.$refs.chargifySubmit.click();
    },
    setPaymentType(paymentType) {
      this.paymentType = paymentType;
    }
  }
};
</script>
